<template>
  <ul
    id="application-nav"
    :style="{ transform: `translate3d(0, ${translateOffset}px, 0)` }"
  >
    <li
      class="nav-item"
      v-for="(configGroup, index) in applicationConfig"
      :key="index"
      v-show="showField(configGroup, applicationData)"
      @click="activeGroup(index)"
      :class="{ active: currentGroupIndex == index }"
    >
      <span class="group-title" v-text="configGroup.title"></span>
      <!-- 能编辑的时候才显示 -->
      <span
        class="status-icon"
        v-if="groupStatus[configGroup.name] !== status.unknown && editable"
        :class="{
          valid: groupStatus[configGroup.name] === status.valid,
          'nav-invalid': groupStatus[configGroup.name] === status.invalid,
        }"
      ></span>
      <span class="fill-space"></span>
      <i></i>
    </li>
  </ul>
</template>

<script>
import applicationFormService from '../../../services/application-form-service';
import applicantConstants from '../../../constants/applicant-constants';

export default {
  name: 'application-nav',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 申请表的配置数组
    applicationConfig: {
      type: Array,
      required: true,
    },

    applicationData: {
      type: Object,
      required: true,
    },

    // v-model的value
    value: {
      type: Number,
      required: true,
      default: 0,
    },

    // 组状态
    groupStatus: {
      type: Object,
      required: true,
      default: () => ({}),
    },

    // 能否编辑
    editable: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      toTop: 0,
      translateOffset: 0,
      status: applicantConstants.APPLICATION_GROUP_STATUS,
      currentGroupIndex: this.value, // 当前选中的组index
    };
  },
  methods: {
    // 字段是否隐藏
    showField: applicationFormService.showField,

    activeGroup(index) {
      this.currentGroupIndex = index;
      this.$emit('input', this.currentGroupIndex);
    },

    // 滚动事件
    scrollEventFun() {
      // 60 是指header的高度
      const bodyScrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (bodyScrollTop <= this.toTop) {
        this.translateOffset = 0;
      } else {
        this.translateOffset = bodyScrollTop - this.toTop;
      }
    },

    // 这个方法获取导航到顶部的距离，用于滑动跟随，但是在预审不通过页面会因为预审不通过提示语在提交成功之后消失
    // 导致距离出现错误，所以在外部也会调用这个函数来重新计算
    setNavToTop(memoHeight) {
      if (typeof memoHeight !== 'undefined' && memoHeight) {
        this.toTop -= memoHeight;
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        this.toTop =
          document.querySelector('.nav-box').getBoundingClientRect().top + 120;
      }
    },
  },
  watch: {
    value(newVal) {
      this.currentGroupIndex = newVal;
    },
  },
  mounted() {
    this.setNavToTop();
    window.addEventListener('scroll', this.scrollEventFun);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEventFun);
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/less/variable";
ul#application-nav {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  li.nav-item {
    width: 100%;
    background-color: white;
    border-bottom: 1px solid @border-light;
    border-right: 1px solid @border-light;
    display: flex;
    padding: 0 20px;
    align-items: center;
    height: 50px;
    cursor: pointer;
    align-items: center;
    span.group-title {
      font-size: 16px;
      color: @text-sliver;
      max-width: 120px;
    }
    span.status-icon {
      width: 20px;
      height: 20px;
      margin-left: 10px;
      background-repeat: no-repeat;
      background-position: center center;
      &.valid {
        background-image: url("../../../assets/imgs/application/valid.png");
      }
      &.nav-invalid {
        background-image: url("../../../assets/imgs/application/invalid.png");
      }
    }
    span.fill-space {
      flex: 1;
    }
    i {
      width: 6px;
      height: 12px;
      background-image: url("../../../assets/imgs/application/arrow-off.png");
      background-repeat: no-repeat;
      background-position: center center;
    }
    &:hover {
      background-color: white;
      span.group-title {
        color: @main;
      }
      span.status-icon {
        &.valid {
          background-image: url("../../../assets/imgs/application/valid.png");
        }
      }
      i {
        background-image: url("../../../assets/imgs/application/arrow-on.png");
      }
    }
    &.active {
      background-color: @main;
      span.group-title {
        color: white;
      }
      span.status-icon {
        &.valid {
          background-image: url("../../../assets/imgs/application/valid-white.png");
        }
      }
      i {
        background-image: url("../../../assets/imgs/application/arrow-off.png");
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-nav.vue